jQuery(document).ready(function ($) {
    $("#wp-admin-bar-new-content a").each(function () {
        const currentUrl = $(this).attr("href");
        const paramsCondition = currentUrl.indexOf("?") === -1 || currentUrl.includes("post_type=page") || currentUrl.includes("post_type=case_studies");

        if (currentUrl.includes("post-new.php") && paramsCondition) {
            const separator = currentUrl.indexOf("?") === -1 ? "?" : "&";
            const newUrl = currentUrl + separator + "no-cache=" + new Date().getTime();
            $(this).attr("href", newUrl);
        }
    });
});